import { v4 as uuidv4 } from "uuid";

function generateUniqueId() {
  //   const timestamp = new Date().getTime();
  //   const random = Math.random().toString(36).substring(2, 10); // Generate a random string
  //   return `${timestamp}${random}`; // Concatenate timestamp and random string
  return uuidv4();
}
export default generateUniqueId;
